import * as yup from "yup";
import FormikCheckbox from "../../../commons/formik/formikCheckbox";
import FormikDatePicker from "../../../commons/formik/formikDatePicker";
import FormikForm from "../../../commons/formik/formikForm";
import FormikTextField from "../../../commons/formik/formikTextField";
import { StyledPaper } from "../../../styled/paper";

// Styled components
import { Box } from "@mui/material";
import {
  StyledSearchAuthorizationsForm,
  StyledSearchContainer,
} from "../../../styled/authorizations";
import { StyledForm } from "../../../styled/form";

// Validation Schema
const validationSchema = yup.object().shape({
  fechaDesde: yup
    .date()
    .nullable()
    .typeError("Fecha inválida")
    .test({
      name: "fechaDesde",
      message: "La fecha desde debe ser menor o igual a la fecha hasta",
      test: function (value) {
        if (this.parent.fechaHasta && value <= this.parent.fechaHasta) {
          return true;
        }
        return false;
      },
    })
    .required("La fecha desde es obligatoria"),

  fechaHasta: yup
    .date()
    .nullable()
    .typeError("Fecha inválida")
    .test({
      name: "fechaHasta",
      message: "La fecha hasta debe ser mayor o igual a la fecha desde",
      test: function (value) {
        if (this.parent.fechaDesde && value >= this.parent.fechaDesde) {
          return true;
        }
        return false;
      },
    })
    .required("La fecha hasta es obligatoria"),
});

// Initial form values
const initialValues = {
  siniestro: "",
  dni: "",
  fechaDesde: null,
  fechaHasta: null,
  otrosPrestadores: false,
};

const SearchAuthorizationForm = ({ handleSubmit, loading }) => {
  return (
    <div>
      <StyledPaper.Container>
        <FormikForm
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}>
          {({ handleSubmit, errors }) => (
            <>

              <StyledSearchContainer.Form>
                <Box
                  sx={{
                    width: "90%",
                    display: "flex",
                  }}>
                  <StyledForm.Input>
                    <FormikTextField
                      name="siniestro"
                      variant="standard"
                      label="Siniestro"
                    />
                  </StyledForm.Input>
                  <StyledForm.Input>
                    <FormikTextField
                      name="dni"
                      variant="standard"
                      label="DNI"
                    />
                  </StyledForm.Input>

                  <StyledForm.Input>
                    <FormikDatePicker
                      name="fechaDesde"
                      variant="standard"
                      label="Fecha Desde"
                    />
                  </StyledForm.Input>

                  <StyledForm.Input>
                    <FormikDatePicker name="fechaHasta" label="Fecha Hasta" />
                  </StyledForm.Input>
                  <StyledForm.Input>
                    <FormikCheckbox
                      id="otrosPrestadores"
                      name="otrosPrestadores"
                      label="¿Incluir otros prestadores?"
                      sx={{ marginLeft: 0 }}
                    />
                  </StyledForm.Input>
                </Box>
                <StyledSearchAuthorizationsForm.ButtonContainer>
                  <StyledSearchAuthorizationsForm.StyledButton
                    variant="contained"
                    type="submit"
                    color="primary"
                    onClick={handleSubmit}
                    disabled={loading}>
                    Buscar
                  </StyledSearchAuthorizationsForm.StyledButton>
                </StyledSearchAuthorizationsForm.ButtonContainer>
              </StyledSearchContainer.Form>
            </>
          )}
        </FormikForm>
      </StyledPaper.Container>
    </div>
  );
};

export default SearchAuthorizationForm;
